module.exports = __webpack_public_path__ + "static/media/pinterest_icon.f54d7de1.svg";